import cn from "classnames";
import { dateDiff, formatDate } from "../helpers/date";
import { TriangleAlert } from "lucide-react";

interface DueDateCellProps {
  dueDate: string | null;
  renderedDate?: string;
  enableColorHighlight?: boolean;
}

export const DueDateCell = ({
  dueDate,
  renderedDate,
  enableColorHighlight = true,
}: DueDateCellProps) => {
  const toDateDiff = dueDate ? dateDiff(dueDate, new Date(), "day") : null;

  const toDatePassed =
    enableColorHighlight && toDateDiff !== null && toDateDiff < 0;

  const toDateClose =
    enableColorHighlight &&
    toDateDiff !== null &&
    toDateDiff <= 5 &&
    toDateDiff >= 0;

  return (
    <div
      className={cn("flex items-center gap-2", {
        "text-orange-500": toDateClose,
        "text-red-500": toDatePassed,
      })}
    >
      {renderedDate ?? formatDate(dueDate)}
      {toDatePassed && <TriangleAlert className="h-5 w-5 text-red-500" />}
    </div>
  );
};
